export default "__VITE_ASSET__CSt$6kaS__"